import React from 'react'
import Select from 'react-select'

export interface IDropdownOption {
  value: string
  label: string
  fileId: number
}

interface Props {
  dropdownOptions: IDropdownOption[]
  onSelectOption(fileId?: number): void
  defaultDropdownOption?: IDropdownOption
}

const DropdownSearchInput: React.FC<Props> = ({
  dropdownOptions,
  onSelectOption,
  defaultDropdownOption,
}) => {
  return (
    <Select
      className="basic-single"
      onChange={(option) => onSelectOption(option?.fileId)}
      classNamePrefix="select"
      isClearable={true}
      isSearchable={true}
      name="color"
      options={dropdownOptions}
      defaultValue={defaultDropdownOption}
    />
  )
}

export default DropdownSearchInput
